import styled from 'styled-components'

import { Text } from '@interco/inter-ui/components/Text'
import { interFont } from '@/styles/fonts'

export const LabelNameCompany = styled.div`
  align-self: start;
  margin: 12px 0 8px;
`

export { Button, ButtonSecondary } from '@/components/Buttons'

export const Label = styled(Text).attrs({
  color: 'typography',
  colorWeight: 400,
  variant: 'body-3',
  semiBold: true,
})`
  ${interFont};
  align-self: start;
  margin: 8px 0 0;
`
